module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-ticad9-bg-2-sp-416aba88d16b76f6627a2e56ba2fec35.png";